import QdtComponents from 'qdt-components'

const testing = false

export default ({ app }, inject) => {
  const host = app.$host
  // 'devdashboards.philasd.org'
  // app.$host

  const appId = testing
    ? 'e3ac99ae-32da-48cd-849d-b32387ae703f'
    : '5bb27291-9904-47d7-a77c-c872126880c8'

  const config = {
    host,
    prefix: '',
    port: 443, // window.location.port,
    secure: true,
    appId
  }
  const connections = {
    vizApi: true,
    engineApi: true
  }
  const qdtComponents = new QdtComponents(config, connections)

  inject('qdt', qdtComponents)
}
